import { ApolloClient, InMemoryCache, createHttpLink, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
// import { useNavigate } from 'react-router-dom'; // If using React Router v6
// or
// import { useHistory } from 'react-router-dom'; // If using React Router v5

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_BASE_URL + '/graphql', // Your GraphQL endpoint
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (networkError && networkError.statusCode === 401) {
    localStorage.removeItem('token');

    // Redirect to the login page
    // Using React Router v6:
    // const navigate = useNavigate();
    // navigate('/login');

    // Using React Router v5:
    // try {
    //   const history = useHistory();
    //   history.push('/login');
    // } catch(error){
    //   console.log(error)
    // }
    window.location.replace("/login")
  }

  // if (graphQLErrors)
  //   graphQLErrors.map(({ message, locations, path }) =>
  //     console.log(
  //       `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
  //     ),
  //   );
});

export const client = new ApolloClient({
  link: ApolloLink.from([errorLink,authLink, httpLink]),
  cache: new InMemoryCache()
});